export default __webpack_public_path__ + "static/media/i227vp.9aa762ca.webp";